import React from "react";

const LegendTable = ({
  data = [],
  className = "",
  classNameLabel = "",
  classNameValue = "",
  classNamePercent = "",
  showDot = true,
}) => {
  return (
    <div className={className}>
      <table className="w-full text-sm">
        <thead>
          <tr className="text-[14px]  text-[#737373]  border-b border-[#D4D4D4] ">
            <th className="text-left font-[500] leading-5 py-2">Label</th>
            <th className="text-center font-[500] leading-5  py-2">Value</th>
            <th className="text-right  font-[500] leading-5 py-2">%</th>
          </tr>
        </thead>
        <tbody>
          {data.map(({ label, value, percent, color }, index) => {
            const validPercent = !isNaN(percent) ? percent : 0;
            const formattedPercent = validPercent % 1 === 0 ? validPercent.toFixed(0) : validPercent.toFixed(2);

            return (
            <tr key={index} className="text-black font-semibold relative top-1">
              <td className={`py-2 ${classNameLabel}`}>
                <div className="flex items-center gap-2">
                  {showDot && (
                <span
                  className="inline-block w-3 h-3 rounded-full"
                  style={{ backgroundColor: color }}
                />
                  )}
                  <span>{label}</span>
                </div>
              </td>
              <td className={`text-center py-2 ${classNameValue}`}>{value}</td>
              <td className={`text-right py-2 ${classNamePercent}`}>{formattedPercent}%</td>
            </tr>
          );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default LegendTable;
